'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./wishlist/wishlist'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./account/pluginLogin'));
    processInclude(require('./product/quickView'));
    processInclude(require('./login/login'));
});
